import { render } from "./InputMatrix.vue?vue&type=template&id=c24cd754"
import script from "./InputMatrix.vue?vue&type=script&lang=js"
export * from "./InputMatrix.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__